import { render, staticRenderFns } from "./PriceListCards.vue?vue&type=template&id=4f2d5e2e&"
import script from "./PriceListCards.vue?vue&type=script&lang=js&"
export * from "./PriceListCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports